import { Box, Card, CardContent, Typography, Stack, Button, Divider } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { Container } from '@mui/material'
import { PublicFooter } from '../components/PublicFooter'
import { PublicNavbar } from '../components/PublicNavbar'
import { PublicPageIntro } from '../components/PublicPageIntro'

export const PrivacyPolicyPage = () => {
  const navigate = useNavigate()

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
      <PublicNavbar />
      <Container maxWidth="md" sx={{ py: { xs: 4, md: 8 } }}>
        <PublicPageIntro
          title="Privacy Policy & Disclaimer"
          description="How athlete and recruiter information is collected, used, and protected on our platform."
        />
        <Button
          onClick={() => navigate(-1)}
          startIcon={<ArrowBack />}
          sx={{ mb: 3 }}
          color="primary"
        >
          Back
        </Button>

        <Card>
          <CardContent sx={{ p: { xs: 3, md: 5 } }}>
            <Stack spacing={4}>
              <Section title="Student Privacy & Disclaimer">
                <Paragraph>
                  By creating a profile on this platform, you agree to provide personal and athletic
                  information such as contact details, academic information, statistics, and media
                  content. This information may be visible to verified coaches and recruiting staff
                  for the purpose of evaluating potential student-athletes. Similar recruiting
                  platforms share athlete profile information with verified coaches to facilitate
                  the recruiting process.
                </Paragraph>
                <Paragraph>
                  While your profile is public, subscribed recruiters can view your contact
                  information and your parent or guardian's, and may export it to contact you about
                  recruiting opportunities.
                </Paragraph>
                <Paragraph>
                  Your information will only be used for recruiting and platform-related services.
                  By registering, you acknowledge and understand that creating a profile or
                  submitting information does not guarantee recruitment, scholarship offers, or
                  contact from coaches.
                </Paragraph>
              </Section>

              <Divider />

              <Section title="Coach Data Access & Privacy Policy">
                <Paragraph>
                  Coaches and recruiting staff who access this platform are granted limited access
                  to student-athlete information solely for the purpose of evaluating and contacting
                  potential recruits. Recruiting platforms commonly allow coaches to view athlete
                  profiles to facilitate recruiting opportunities while maintaining data
                  protections.
                </Paragraph>
                <Paragraph>
                  All athlete data available on the platform is confidential and protected under our
                  data privacy policy. Coaches may not copy, distribute, share, or use athlete
                  information for purposes unrelated to legitimate recruiting activities. Similar
                  policies require that player contact information not be disclosed outside the
                  recruiting staff or organization.
                </Paragraph>
                <Paragraph>
                  Coaches are prohibited from selling, redistributing, or publicly sharing athlete
                  data. Any misuse of platform data or violation of privacy guidelines may result in
                  suspension or termination of access to the platform.
                </Paragraph>
              </Section>
            </Stack>
          </CardContent>
        </Card>
      </Container>
      <Box sx={{ mt: 2 }}>
        <PublicFooter />
      </Box>
    </Box>
  )
}

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <Box>
    <Typography variant="h5" component="h2" sx={{ fontWeight: 700, mb: 2 }}>
      {title}
    </Typography>
    <Stack spacing={2}>{children}</Stack>
  </Box>
)

const Paragraph = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="body1" color="text.primary" sx={{ lineHeight: 1.7 }}>
    {children}
  </Typography>
)
